import ReactDOM from 'react-dom';
import moment from "moment-timezone";
import CryptoJS from "react-native-crypto-js";
import { PARAM_COOKIE_TRANSVERSAL_START_NAME, PARAM_COOKIE_TRANSVERSAL_HELP_CONFIG, PARAM_NAME_TOKEN, PARAM_COOKIE_TRANSVERSAL_BOARD_FIELD_DISPLAY, PARAM_COOKIE_TRANSVERSAL_LOCALE_CONFIG, PARAM_COOKIE_TRANSVERSAL_BOARD_CALENDAR_CONFIG, PARAM_NAME_TOKEN_OLD } from "../configurations/strings.config";
import { __BoardFilterFields_DefaultValues, __KPIAgregations, enum__MessageStatus, enum__Objetives, enum__PRIVILEGES, __DueDayRule, enum__DueDayRule, enum__TimeScale } from "./Dictionaries";
import { __OBJECT_STRUCTURE_GetFilter } from "./ObjectStructures/sKPI";
import * as XLSX from 'xlsx';
import { WEB_AUTH_URL, WEB_CORE_URL } from "../configurations/paths.config";
import axios from "axios";
import { authHeaderJson } from "../services/auth-header.service";
//import QRCode from "react-qr-code";
//import { Canvg } from 'canvg';
import QRCodePNG from "qrcode";

const isNullOrEmpty = (elementProperty) => {
    return elementProperty === null || elementProperty === "";
};

const isNullUndefined = (elementProperty) => {
    return elementProperty === null || elementProperty === undefined;
};

const isNullUndefinedOrEmpty = (elementProperty) => {
    return elementProperty === null || elementProperty === undefined || elementProperty === "";
};

const isNullUndefinedOrEmptyOrZero = (elementProperty) => {
    return elementProperty === null || elementProperty === undefined || elementProperty === "" || elementProperty === "0" || elementProperty === 0;
};

const isNullUndefinedOrEmptyOrNegative = (elementProperty) => {
    return elementProperty === null || elementProperty === undefined || elementProperty === "" || elementProperty < 0;
};

const isNullUndefinedOrNegative = (elementProperty) => {
    return elementProperty === null || elementProperty === undefined || elementProperty < 0;
};

const firstDayNextMonthAYearBefore = (date) => {
  const d = new Date(date.getTime());
  d.setFullYear(d.getFullYear() - 1);
  return new Date(d.getFullYear(), d.getMonth() + 1, 1);
}

const parseMesAnioEs = (input) => {
if (!input) return moment.invalid();

  const norm = String(input)
    .normalize('NFKC')       // normaliza Unicode
    .replace(/\u00A0/g, ' ') // NBSP → espacio normal
    .replace(/\s+/g, ' ')    // colapsa espacios múltiples
    .trim()
    .toLowerCase();

  let m = moment(norm, 'MMMM [de] YYYY', 'es', true);
  if (m.isValid()) return m;

  m = moment(norm, 'MMMM YYYY', 'es', true);
  if (m.isValid()) return m;

  const months = {
    'enero': 0, 'febrero': 1, 'marzo': 2, 'abril': 3, 'mayo': 4, 'junio': 5,
    'julio': 6, 'agosto': 7, 'septiembre': 8,
    'octubre': 9, 'noviembre': 10, 'diciembre': 11,
  };

  const match = norm.match(/^([a-záéíóúñ]+)\s+(?:de\s+)?(\d{4})$/i);
  if (match) {
    const mes = months[match[1]];
    const anio = parseInt(match[2], 10);
    if (mes != null && Number.isInteger(anio)) {
      return moment({ year: anio, month: mes, day: 1 });
    }
  }

  return moment.invalid();
}

const parseMesAnioEsByDate = (input) => {
    if (!input) return moment.invalid();


    let m = moment(input);
    if (m.isValid()) return m;

    const nro_mes = moment(input).format('M');
    const nro_year = moment(input).format('YYYY');


    const months = {
        'enero': 1, 'febrero': 2, 'marzo': 3, 'abril': 4, 'mayo': 5, 'junio': 6,
        'julio': 7, 'agosto': 8, 'septiembre': 9,
        'octubre': 10, 'noviembre': 11, 'diciembre': 12,
    };

    const mes_texto = months[nro_mes];

    const full_date = `${mes_texto} de ${nro_year}`

    const match = input.match(/^([a-záéíóúñ]+)\s+(?:de\s+)?(\d{4})$/i);
    if (match) {
        const mes = months[match[1]];
        const anio = parseInt(match[2], 10);
        if (mes != null && Number.isInteger(anio)) {
        return moment({ year: anio, month: mes, day: 1 });
        }
    }

    return moment.invalid();
}

const getGridLocalization = (t) => {
    const localizationobj = {};
    localizationobj.pagerGoToPageString = 'Ir a:';
    localizationobj.pagerShowRowsString = 'Mostrar línea:';
    localizationobj.pagerRangeString = ' de ';
    localizationobj.pagerNextButtonString = 'anterior';
    localizationobj.pagerFirstButtonString = 'primero';
    localizationobj.pagerLastButtonString = 'último';
    localizationobj.pagerPreviousButtonString = 'próximo';
    localizationobj.sortAscendingString = 'Ordenar ascendente';
    localizationobj.sortDescendingString = 'Orden descendiente';
    localizationobj.sortRemoveString = 'Quitar orden';
    localizationobj.emptydatastring = 'no se muestran datos';
    localizationobj.firstDay = 1;
    localizationobj.percentSymbol = '%';
    localizationobj.currencySymbol = '$';
    //[##]localizationobj.currencySymbolPosition = 'after';
    localizationobj.decimalSeparator = ',';
    localizationobj.thousandsSeparator = '.';
    localizationobj.todaystring = "Hoy";
    localizationobj.clearstring = "Borrar";
    const days = {
        names: [t('data-lang-days-sunday'), 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'],
        namesAbbr: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
        namesShort: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
    };
    localizationobj.days = days;
    const months = {
        names: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre', ''],
        namesAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic', '']
    };
    const patterns = {
        D: 'dddd, d. MMMM yyyy',
        F: 'dddd, d. MMMM yyyy HH:mm:ss',
        M: 'dd MMMM',
        T: 'HH:mm:ss',
        Y: 'MMMM yyyy',
        d: 'dd.MM.yyyy',
        f: 'dddd, d. MMMM yyyy HH:mm',
        t: 'HH:mm'
    };
    localizationobj.patterns = patterns;
    localizationobj.months = months;
    localizationobj.filterchoosestring = t('data-lang-lbl-select');

    return localizationobj;
};

const treeify = (list, idAttr, parentAttr, childrenAttr, codeAttr, nameAttr) => {
    if (!idAttr) idAttr = 'id';
    if (!parentAttr) parentAttr = 'parent';
    if (!childrenAttr) childrenAttr = 'children';
  
    let treeList = [];
    let lookup = {};
    list.forEach(function(obj) {
        lookup[obj[idAttr]] = obj;
        obj[childrenAttr] = [];
        obj["value"] = obj.id;
        if (codeAttr !== undefined && codeAttr !== null && codeAttr !== "") {
            if (nameAttr !== undefined && nameAttr !== null && nameAttr !== "") {
                obj["label"] = `${obj[codeAttr]}: ${obj[nameAttr]}`;
            }
            else {
                obj["label"] = `${obj[codeAttr]}: ${obj.name}`;
            }
        }
        else {
            if (nameAttr !== undefined && nameAttr !== null && nameAttr !== "") {
                obj["label"] = `${obj[nameAttr]}`;
            }
            else {
                obj["label"] = `${obj.name}`;
            }
        }
        obj["tagClassName"] = obj[parentAttr] === null ? "special" : "";
        
    });
    list.forEach(function(obj) {
        if (obj[parentAttr] !== null) {
            if (lookup[obj[parentAttr]] !== undefined) {
                lookup[obj[parentAttr]][childrenAttr].push(obj);
            } else {
                treeList.push(obj);
            }               
        } else {
            treeList.push(obj);
        }
    });
    return treeList;
};

const joinWithoutDupes = (initialData, newData, keyFieldName, pushOnlyParamCompared = false) => {
    let ids = new Set(initialData.map(d => d[keyFieldName] !== undefined ? d[keyFieldName] : d));
    let merged = [...initialData, ...newData.filter(d => !ids.has((d[keyFieldName] !== undefined ? d[keyFieldName] : d))).map(x => x[keyFieldName] !== undefined ? (pushOnlyParamCompared ? x[keyFieldName] : x) : x)];

    return merged;
}

const getKeyByValue = (object, key) => {
    return object[key] ? object[key] : object["none"];
}

const getKeyByDictionary = (object, value) => {
    return Object.keys(object).find(key => object[key] === value);
}

const visibilityButtonSaveWMessageId = (objMensajeId, objMensajeStatusId, userProps, requiresApproval) => {
    let hide = null;
    const aux_userProps_CanSave = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix && x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE || y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;
    if (objMensajeId === null) {
        hide = false;
    }
    else {
        //4# Enviada.
        if (objMensajeStatusId !== enum__MessageStatus.SENDED) {
            if (aux_userProps_CanSave) {
                if (requiresApproval !== null && requiresApproval === true) {
                    //Requiere aprobación.
                    hide = false;
                }
                else {
                    //No requiere aprobación.
                    hide = false;
                }
            }
            else {
                hide = true;
            }
        }
        else {
            hide = true;
        }
    }

    return hide;
}

const visibilityButtonSave = (objMensajeStatusId, userProps, requiresApproval, visaStatus = null) => {
    let hide = null;
    const aux_userProps_CanSave = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE || y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;
    //4# Enviada.
    if (objMensajeStatusId !== enum__MessageStatus.SENDED && objMensajeStatusId !== enum__MessageStatus.TOVISA) {
        if (aux_userProps_CanSave) {
            if (requiresApproval !== null && requiresApproval === true) {
                //Requiere aprobación.
                hide = false;
            }
            else {
                //No requiere aprobación.
                hide = false;
            }
        }
        else {
            hide = true;
        }
    }
    else {
        if (objMensajeStatusId === enum__MessageStatus.TOVISA) {
            if (visaStatus === 3 || visaStatus === 2) {
                hide = false;
            }
            else {
                hide = true;
            }
        }
        else {
            hide = true;
        }
    }

    return hide;
}

const visibilityButtonCirculateWMessageId  = (objMensajeId, objMensajeStatusId, userProps, requiresApproval) => {
    let hide = null;
    const aux_userProps_CanCirculate = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE || y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;
    if (objMensajeId === null) {
        if (aux_userProps_CanCirculate) {
            hide = false;
        }
        else {
            hide = true;
        }
    }
    else {
        //4# Enviada.
        if (objMensajeStatusId === enum__MessageStatus.ONPRAPARATION || objMensajeStatusId === null) {
            if (aux_userProps_CanCirculate) {
                if (requiresApproval !== null && requiresApproval === true) {
                    //Requiere aprobación.
                    hide = false;
                }
                else {
                    //No requiere aprobación.
                    hide = false;
                }
            }
            else {
                hide = true;
            }
        }
        else {
            hide = true;
        }
    }
    return hide;
}

const visibilityButtonCirculate = (objMensajeStatusId, userProps, requiresApproval) => {
    let hide = null;
    const aux_userProps_CanCirculate = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE || y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;
    //4# Enviada.
    if (objMensajeStatusId === enum__MessageStatus.ONPRAPARATION || objMensajeStatusId === null) {
        if (aux_userProps_CanCirculate) {
            if (requiresApproval !== null && requiresApproval === true) {
                //Requiere aprobación.
                hide = false;
            }
            else {
                //No requiere aprobación.
                hide = false;
            }
        }
        else {
            hide = true;
        }
    }
    else {
        hide = true;
    }

    return hide;
}

const visibilityButtonSendToApprove = (objMensajeStatusId, userProps, requiresApproval) => {
    let hide = null;
    const aux_userProps_CanSend = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE)) === true) !== undefined;

    const aux_userProps_CanColaborate = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;

    //4# Enviada.
    if (objMensajeStatusId === enum__MessageStatus.ONPRAPARATION || objMensajeStatusId === enum__MessageStatus.ONCIRCULATION || objMensajeStatusId === null) {
        if (aux_userProps_CanSend && aux_userProps_CanColaborate) {
            hide = true;
        }
        else {
            if (aux_userProps_CanSend) {
                hide = true;
            }
            else {
                if (requiresApproval !== null && requiresApproval === true) {
                    if (aux_userProps_CanColaborate) {
                        hide = false;
                    }
                    else {
                        hide = true;
                    }
                }
                else {
                    hide = true;
                }
            }
        }
    }
    else {
        hide = true;
    }
    return hide;
}

const visibilityControlSendToVisa = (objMensajeStatusId, userProps, requiresApproval) => {
    let hide = null;
    const aux_userProps_CanSend = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE)) === true) !== undefined;

    const aux_userProps_CanColaborate = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;

    const aux_userProps_IsManagerPartyMember = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.managerParty === true) !== undefined;   

    if (aux_userProps_IsManagerPartyMember === true) {
        if (objMensajeStatusId === enum__MessageStatus.ONPRAPARATION || objMensajeStatusId === enum__MessageStatus.ONCIRCULATION || objMensajeStatusId === null) {
            if (aux_userProps_CanSend && aux_userProps_CanColaborate) {
                hide = false;
            }
            else {
                if (aux_userProps_CanSend) {
                    hide = false;
                }
                else {
                    if (requiresApproval !== null && requiresApproval === true) {
                        if (aux_userProps_CanColaborate) {
                            hide = true;
                        }
                        else {
                            hide = true;
                        }
                    }
                    else {
                        hide = true;
                    }
                }
            }
        }
        else {
            hide = true;
        }
    }
    else {
        hide = true;
    }

    return hide;
}

const visibilityButtonSend = (objMensajeId, objMensajeStatusId, userProps, requiresApproval, isCreationMode, visaAnswered = false) => {
    let hide = null;
    const aux_userProps_CanSend = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE)) === true) !== undefined;

    const aux_userProps_isApprover = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;

    /*const aux_userProps_isCreator = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;*/

    //4# Enviada.
    if (isCreationMode === true && isNullUndefinedOrEmptyOrZero(objMensajeId)) {
        if (aux_userProps_CanSend === true && requiresApproval === true) {
            return false;
        }
        else if (aux_userProps_isApprover === true && requiresApproval === false) {
            return false;
        }
        else {
            return true;
        }
    }

    if (objMensajeStatusId !== enum__MessageStatus.SENDED && objMensajeStatusId !== enum__MessageStatus.TOVISA) {
        if (requiresApproval === true) {
            if (aux_userProps_CanSend) {
                hide = false;
            }
            else if (aux_userProps_isApprover === true) {
                hide = true;
            }
            else {
                hide = true;
            }
        }
        else {
            if (aux_userProps_CanSend || aux_userProps_isApprover) {
                hide = false;
            }
            else {
                hide = true;
            }
        }
    }
    else if (objMensajeStatusId === enum__MessageStatus.TOVISA) {
        if (visaAnswered === true ) {
            if (requiresApproval === true) {
                if (aux_userProps_CanSend) {
                    hide = false;
                }
                else if (aux_userProps_isApprover === true) {
                    hide = true;
                }
                else {
                    hide = true;
                }
            }
            else {
                if (aux_userProps_CanSend || aux_userProps_isApprover) {
                    hide = false;
                }
                else {
                    hide = true;
                }
            }
        }
        else {
            hide = true;
        }
    }
    else {
        hide = true;
    }

    return hide;
}

const visibilityButtonBreakeVisa = (objMensajeStatusId, userProps, requiresApproval, requiresVisa) => {
    let hide = null;
    const aux_userProps_CanSend = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE)) === true) !== undefined;

    const aux_userProps_isApprover = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;

    if (objMensajeStatusId === enum__MessageStatus.TOVISA) {
        if (requiresApproval === true) {
            if (aux_userProps_CanSend && requiresVisa === true) {
                hide = false;
            }
            else if (aux_userProps_isApprover === true) {
                hide = true;
            }
            else {
                hide = true;
            }
        }
        else {
            if ((aux_userProps_CanSend || aux_userProps_isApprover) && requiresVisa === true) {
                hide = false;
            }
            else {
                hide = true;
            }
        }
    }
    else {
        hide = true;
    }

    return hide;
}

const visibilityButtonDelete = (objMensajeStatusId, userProps, requiresVisa = false, visaBreaked = false) => {
    let hide = null;
    const aux_userProps_CanDelete = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE || y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;
    //Borrador: cualquier comunicación no enviada, igual que la API (MessageRules.CanDeleteMessage).
    if (objMensajeStatusId === enum__MessageStatus.ONPRAPARATION || objMensajeStatusId === enum__MessageStatus.ONCIRCULATION ||
        objMensajeStatusId === enum__MessageStatus.ONAPROBATION || objMensajeStatusId === enum__MessageStatus.TOVISA) {
        if (aux_userProps_CanDelete) {
            if (requiresVisa) {
                if (visaBreaked) {
                    hide = false;
                }
                else {
                    hide = true;
                }
            }
            else {
                hide = false;
            }
        }
        else {
            hide = true;
        }
    }
    else {
        hide = true;
    }

    return hide;
}

const visibilityButtonSignMessage = (autoSignature, requiresApproval, userProps, sendedPartyId, messageStatusId, messageHasSignature) => {
    let hide = null;
    const aux_userProps_CanSignatureParty = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.elementPartyId === sendedPartyId && x.l_matrix.some(
            y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE || y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;
    const aux_userProps_CanApproveParty = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.elementPartyId === sendedPartyId && x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE)) === true) !== undefined;
    if (autoSignature === true) {
        hide = true
    }
    else {
        //if ((requiresApproval === true) && (userProps.roleId === enum__BookRoles.Aprobador && userProps.partyId === sendedPartyId) && (messageHasSignature === false)) {
        if ((requiresApproval === true) && aux_userProps_CanApproveParty && (messageHasSignature === false)) {
            hide = false;
        }
        //else if ((requiresApproval === false) && ((userProps.roleId === enum__BookRoles.Creador || userProps.roleId === enum__BookRoles.Aprobador) && userProps.partyId === sendedPartyId) && (messageHasSignature === false)) {
        else if ((requiresApproval === false) && aux_userProps_CanSignatureParty && (messageHasSignature === false)) {
            hide = false;
        }
        else {
            hide = true;
        }
    }

    return hide;
}

const isBookApproverOrCreator = (userProps) => {
    const aux_userProps = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.username !== null && x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE || y.actionCode === enum__PRIVILEGES.BOOK_CREATE)) === true) !== undefined;
    return aux_userProps;
}

const isBookApprover = (userProps) => {
    const aux_userProps = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.username !== null && x.l_matrix.some(y => (y.actionCode === enum__PRIVILEGES.BOOK_APPROVE)) === true) !== undefined;
    return aux_userProps;
}

const isBookConfigureRol = (userProps) => {
    const aux_userProps = userProps && userProps.l_privilegeselement && userProps.l_privilegeselement.find(
        x => x.username !== null && x.l_matrix.some(
            y => (y.actionCode === enum__PRIVILEGES.BOOK_CONFIG)) !== undefined) !== undefined;
    return aux_userProps;
}

const downloadURI = (uri, filename) => {
    const link = document.createElement("a");
    link.href = uri;
    link.download = filename;
    link.target = "_blank";
    link.click();
    document.body.removeChild(link);

    /*
    fetch(uri).then(response => response.blob()).then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.target = "_blank";
        link.click();
        document.body.removeChild(link);
    }).catch(console.error);*/
}

const getAuth = (PARAM_NAME) => {
    let name = PARAM_NAME;
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name+"=") === 0) {
            return c.substring((name+"=").length, c.length);
        }
        if (c.indexOf(name+"2=") === 0) {
            return c.substring((name+"2=").length, c.length)
        }
    }

    return null;
}











const chunkArray = (myArray, chunk_size) => {
    let index = 0;
    let arrayLength = myArray.length;
    let tempArray = [];
    
    for (index = 0; index < arrayLength; index += chunk_size) {
        const myChunk = myArray.slice(index, index+chunk_size);
        // Do something if you want with the group
        tempArray.push(myChunk);
    }

    return tempArray;
}

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

const base64ToArrayBuffer = (base64) => {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
       let ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
}

const base64ToBlob = (base64, mime) => {
  const bytes = atob(base64);
  const array = Uint8Array.from(bytes, c => c.charCodeAt(0));
  return new Blob([array], { type: mime });
}

const saveByteArray = (reportName, byte) => {
    let blob = new Blob([byte], {type: "application/octet-stream"});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    let fileName = reportName;
    link.download = fileName;
    link.click();
    link.remove();
};

const setHelpConfig = () => {
    let value = getHelpConfig();

    if (value === null) {
        localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_HELP_CONFIG}`, false)
    }
    else {
        localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_HELP_CONFIG}`, !value)
    }

    return getHelpConfig();
};
const getHelpConfig = () => {
    let value = null;

    value = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_HELP_CONFIG}`);

    if (value === null || value === undefined) {
        value = false;
    }

    return JSON.parse(value);
};
const setLocalStorageValue = (PARAM_COOKIE_NAME, value) => {
    if (value === null) {
        localStorage.setItem(`${PARAM_COOKIE_NAME}`, null)
    }
    else {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value === null || value === undefined) {
            localStorage.setItem(`${PARAM_COOKIE_NAME}`, value)
        } else if (typeof value === 'object' && Array.isArray(value)) {
            localStorage.setItem(`${PARAM_COOKIE_NAME}`, JSON.stringify(value))
        } else if (typeof value === 'object' && value !== null) {
            localStorage.setItem(`${PARAM_COOKIE_NAME}`, JSON.stringify(value))
        }
    }

    return getLocalStorageValue(PARAM_COOKIE_NAME);
};
const getLocalStorageValue = (PARAM_COOKIE_NAME, _value, needSetValue = true) => {
    let value = null;

    value = localStorage.getItem(`${PARAM_COOKIE_NAME}`);

    if (needSetValue === true) {
        if (value === null || value === undefined || value === "undefined") {
            value = setLocalStorageValue(PARAM_COOKIE_NAME, (_value === null || _value === undefined) ? {} : _value);
        }        
    }

    return value !== null ? JSON.parse(value) : null;
};

const getLocaleConfig = () => {
    let value = null;

    value = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_LOCALE_CONFIG}`);

    if (value === null || value === undefined) {
        value = "es";
    }

    return value;
};

const setBoardFieldDisplay = (array) => {
    let value = getBoardFieldDisplay();

    if (value === null) {
        localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_BOARD_FIELD_DISPLAY}`, JSON.stringify(__BoardFilterFields_DefaultValues))
    }
    else {
        localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_BOARD_FIELD_DISPLAY}`, JSON.stringify(array))
    }

    return getBoardFieldDisplay();
};

const getBoardFieldDisplay = () => {
    let value = null;

    try {
        value = JSON.parse(localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_BOARD_FIELD_DISPLAY}`));

        if (value === null || value === undefined) {
            value = __BoardFilterFields_DefaultValues;
        }
    } catch (error) {
        value = __BoardFilterFields_DefaultValues;
    }

    return value;
};
const nestedCopy = (array)=> {
    return JSON.parse(JSON.stringify(array));
}
const setBoardCalendarFilterConfig = (_value) => {
    if (_value === null) {
        localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_BOARD_CALENDAR_CONFIG}`, JSON.stringify(__OBJECT_STRUCTURE_GetFilter()))
    }
    else {
        localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_BOARD_CALENDAR_CONFIG}`, JSON.stringify(_value))
    }

    return getBoardCalendarFilterConfig();
};

const getBoardCalendarFilterConfig = () => {
    let value = null;

    try {
        value = JSON.parse(localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_BOARD_CALENDAR_CONFIG}`));

        if (value === null || value === undefined) {
            value = (__OBJECT_STRUCTURE_GetFilter());
        }
        else {
            if (value.periodEndsDate === null || value.periodStartDate === null) {
                value = __OBJECT_STRUCTURE_GetFilter();
            }
            else {
                value.periodEndsDate = moment(value.periodEndsDate).toDate();
                value.periodStartDate = moment(value.periodStartDate).toDate();
            }
        }
    } catch (error) {
        value = __OBJECT_STRUCTURE_GetFilter();
    }

    return value;
};

const removeSpecificTags = (htmlString) => {
  const tagsToRemove = ['span'];
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  tagsToRemove.forEach(tag => {
    doc.querySelectorAll(tag).forEach(el => {
      // Reemplaza el tag por su contenido interno
      const fragment = document.createDocumentFragment();
      while (el.firstChild) fragment.appendChild(el.firstChild);
      el.replaceWith(fragment);
    });
  });

  return doc.body.innerHTML;
};

const setGlobalListPageSize = (listLocalStoragePageSizeVariableName, count) => {
    let globalPageSize = null;

    localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.pageSize.${listLocalStoragePageSizeVariableName}`, count)
    globalPageSize = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.pageSize.${listLocalStoragePageSizeVariableName}`);

    return globalPageSize;
};

const setGlobalMessageLayout = (version) => {
    let globalMessageLayout = null;

    localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.messageLayout`, version)
    globalMessageLayout = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.messageLayout`);

    return globalMessageLayout;
};
const getGlobalMessageLayout = () => {
    let globalMessageLayout = null;

    globalMessageLayout = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.messageLayout`);

    if (globalMessageLayout === null || globalMessageLayout === undefined) {
        globalMessageLayout = "V3";
        setGlobalMessageLayout(globalMessageLayout)
    }

    return globalMessageLayout;
};

const getGlobalListPageSize = (listLocalStoragePageSizeVariableName) => {
    let globalPageSize = null;

    globalPageSize = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.pageSize.${listLocalStoragePageSizeVariableName}`);

    if (globalPageSize === null || globalPageSize === undefined) {
        globalPageSize = 10;
    }

    return parseInt(globalPageSize);
};

const setGlobalCompactViewMode = (componentName, compact) => {
    let global = null;

    localStorage.setItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.compactView.${componentName}`, compact)
    global = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.compactView.${componentName}`);

    return global;
};

const getGlobalCompactViewMode = (componentName) => {
    let global = null;

    global = localStorage.getItem(`${PARAM_COOKIE_TRANSVERSAL_START_NAME}.compactView.${componentName}`);

    return global;
};

const encryptBase64 = (msg, pass) => {
    let ciphertext = CryptoJS.AES.encrypt(msg, pass).toString();

    return ciphertext;
}

const decryptBase64 = (transitmessage, pass) => {
    let bytes  = CryptoJS.AES.decrypt(transitmessage, pass);
    let originalText = bytes.toString(CryptoJS.enc.Utf8);

    return originalText
}

const calculateTimeLeft = (startDate, endDate) => {
    let difference = +endDate - +startDate;
  
    let timeLeft = {};
  
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
  
    return timeLeft;
}

const stringFormat = (theString, argumentArray) => {
    let regex = /%s/;
    let _r=function(p,c){return p.replace(regex,c);}
    return argumentArray.reduce(_r, theString);
}

const fieldSorter = (fields) => {
    return function (a, b) {
        return fields
            .map(function (o) {
                let dir = 1;
                if (o[0] === '-') {
                   dir = -1;
                   o=o.substring(1);
                }
                if (a[o] > b[o]) return dir;
                if (a[o] < b[o]) return -(dir);
                return 0;
            })
            .reduce(function firstNonZeroValue (p,n) {
                return p ? p : n;
            }, 0);
    };
}

const checkIfSelectedSectionStadisticTypeCanBeDisplay = (selectedStadisticType, message) => {
    let flag = true;

    if (selectedStadisticType === null) {
        return flag;
    }
    
    switch (selectedStadisticType.type) {
        case "isTotalMessage":
            flag = true;
            break;
        case "isReceived":
            flag = message.item_message.isReceived;
            break;
        case "isSent":
            flag = message.item_message.isSent;
            break;
        case "isUnread":
            flag = message.item_message.isUnread;
            break;
        case "isPending":
            flag = message.item_message.isPending;
            break;
        case "isExpired":
            flag = message.item_message.isExpired;
            break;
        case "isPendingWaiting":
            flag = message.item_message.isPendingWaiting;
            break;
        case "isExpiredWaiting":
            flag = message.item_message.isExpiredWaiting;
            break;
        default:
            break;
    }

    return flag
}

const isValidDate = (dateString) => {
    let timestamp = Date.parse(dateString);

    return (isNaN(timestamp) === false)
}

const validateZeroAchievementFactorValue = (objetiveId, zeroAchievementFactorVale) => {
    let flagValue = false;
    switch (objetiveId) {
        case enum__Objetives.MAXIMIZE:
            flagValue = (zeroAchievementFactorVale >= 0 && zeroAchievementFactorVale < 1) ? true : false; 
            break;
        case enum__Objetives.MINIMIZE:
            flagValue = (zeroAchievementFactorVale > 1) ? true : false; 
            break;
        case enum__Objetives.MATCH:
            flagValue = (zeroAchievementFactorVale >= 1 && zeroAchievementFactorVale <= 2) ? true : false; 
            break;
        case enum__Objetives.STABILIZE:
            flagValue = (zeroAchievementFactorVale >= 0 && zeroAchievementFactorVale <= 2) ? true : false; 
            break;
        default:
            flagValue = (zeroAchievementFactorVale >= 0 && zeroAchievementFactorVale <= 2) ? true : false; 
            break;
    }

    return flagValue;
}

const download = (base64FFile, type, linkExport, exportFileName, defaultExportFileName) => {
    const arrayBuffer = base64ToArrayBuffer(base64FFile);

    let blob = new Blob([arrayBuffer], { type: type });
    let url = URL.createObjectURL(blob);
    let fileName = (defaultExportFileName +"_"+ moment(new Date()).format("DD_MM_YYYY_HH_mm_ss")).replaceAll(" ", "_");
    linkExport.href = (url);
    linkExport.download = exportFileName !== null || exportFileName !== undefined ? exportFileName.replaceAll(" ", "_") : fileName;
    linkExport.click();
}

const downloadFile = (base64, fileName) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
  
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
  
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
  
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  
    window.URL.revokeObjectURL(link.href);
    link.remove();
};

const downloadCSV = (stringData, type, linkExport, exportFileName) => {
    linkExport.href = type + encodeURI(stringData);
    linkExport.download = exportFileName.replaceAll(" ", "_");
    linkExport.click();
}

const formatNumber = (numberString, decimalDigits = 2) => {
    const number = parseFloat(numberString);
    if (isNaN(number)) return numberString;

    return new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: isNullUndefinedOrEmpty(decimalDigits) ? 2 : decimalDigits,
        maximumFractionDigits: isNullUndefinedOrEmpty(decimalDigits) ? 2 : decimalDigits,
    }).format(number);
};

const groupList = (arr, propertyName) => {
    let headers = [],
        objs = [],
        i, j;
    for (i = 0; i < arr.length; ++i) {
        j = headers.indexOf(arr[i][propertyName]);
        if (j === -1) { 
            j = headers.length;
            headers[j] = arr[i][propertyName];
            objs[j] = {};
            objs[j][propertyName] = arr[i][propertyName];
            objs[j].items = [];
        }
        objs[j].items.push(
            arr[i]
        );
    }
    return objs;
}

const compareKeys = (a, b) => {
    let aKeys = Object.keys(a).sort();
    let bKeys = Object.keys(b).sort();
    return JSON.stringify(aKeys) === JSON.stringify(bKeys);
}

const insertAfter = (referenceNode, newNode) => {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

const dynamicSort = (property) => {
    let sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

function convertToMilitarHour(numeroHora) {
    var hora = Math.floor(numeroHora / 100); // obtener las horas
    var minutos = numeroHora % 100; // obtener los minutos
    var horaTexto = hora.toString().padStart(2, '0'); // convertir la hora a texto y añadir un 0 si es necesario
    var minutosTexto = minutos.toString().padStart(2, '0'); // convertir los minutos a texto y añadir un 0 si es necesario
    return horaTexto + minutosTexto; // concatenar la hora y los minutos en un solo texto
}

const addFieldPropertyToDropDownList = (list, fieldNameString) => {
    const _listaux = [];

    list.forEach(element => {
        _listaux.push({id: element.key, key: element.key, field: fieldNameString, text: element.text, title: element.title})
    });

    return _listaux;
}

const isDecimalValue = (value) => {
    let containLetters = /[a-zA-Z~`!@#$%^&*()=:.;'"<>/?|\\}{}[\]]/.test(value);
    let containComma = /[,]/.test(value);

    let containLetters2 = /[a-zA-Z~`!@#$%^&*()=:.;'"<>/?|\\}{}[\]]/.test(value.replace(',', ''));
    
    let containTwoCommas = !/^[^,]*,?[^,]*$/.test(value);

    return containLetters ?
        (
            containComma ?
            (containTwoCommas ?
                false :
                (containLetters2 ?
                    false :
                    !isNaN(value))
        ) : false) :
        containComma ? (containTwoCommas ? false : !isNaN(value)) : !isNaN(value);
}

const processKpiValsByOperation = (itemList, fieldList, operator) => {
    const kpi_operator = __KPIAgregations.find(x => x.key === operator);

    const processed_vals = itemList.reduce((data, val) => {
        fieldList.forEach(field => {
            data[field] = (data[field] || 0) + val[field]
        });

        return data;
    }, {});

    switch (kpi_operator.key) {
        case 1:
            //Nothing to do.
            break;
        case 2:
            fieldList.forEach(field => {
                processed_vals[field] = processed_vals[field] / itemList.length
            });
            break;
        default:
            //Nothing to do.
            break;
    }

    return processed_vals;
}


const changeCalendarPickerLanguage = (object, t) => {
    for (let property in object) {
        if (Array.isArray(object[property])) {
            for (let i = 0; i < object[property].length; i++) {
                object[property][i] = t(object[property][i])
            }
        } else {
            object[property] = t(object[property])
        }
    }
}

const showMessage = (setter, show, type, message) => {
    setter({
        message: message,
        messageType: type,
        showMessage: show,
    })
}

const getNextTechStepBoardConfig = (_currentStep) => {
    switch (_currentStep) {
        case 0:
        return `#dropdownSelectTempleteType`
        case 1:
        return `#btnConfigureBoard`
        case 2:
        return `#btnAddContainer`  
        case 3:
        return `#btnContainer1`  
        case 4:
        return `#btnSaveBoard`        
        default:
        return undefined        
    }
}

const getNextTechStepGapPage = (_currentStep) => {
    switch (_currentStep) {
        case 0:
        return `#btnGapReview`
        case 1:
        return `#btnNewRevision`
        case 2:
        return `#crdSelectGap`
        case 3:
        return `#btnFishboneType_SelectCauses`
        case 4:
        return `#btnFishboneType_SelectCauses`
        case 5:
        return `#btnProcessSelectedCauses`
        case 6:
        return `#crdCreateActions`
        case 7:
        return `#rowProcessGap`
        default:
        return undefined        
    }
}

const getNextTechStepBulkUpload = (_currentStep) => {
    switch (_currentStep) {
        case 0:
        return `#btnGetTemplate`
        case 1:
        return `#btnSelectFile`
        case 2:
        return `#btnUploadFile`  
        case 3:
        return `#btnProcessFile`      
        default:
        return undefined        
    }
}

const canEditBoardOrGap = (value) => {
    return value.onlyObserver === false && value.hasRole && value.l_privilegeselement.filter(x => x.l_roles.filter(y => y.id === enum__PRIVILEGES.KPI_CONTRACT_CREATE).length > 0 ||  x.l_roles.filter(y => y.id === enum__PRIVILEGES.GAP_CONTRACT_ANALYZE).length > 0).length > 0;
};

const canEditBoardOrGapByElement = (value, elementId) => {
    return value.onlyObserver === false && value.hasRole && value.l_privilegeselement.filter(x => x.elementId === elementId && (x.l_roles.filter(y => y.id === enum__PRIVILEGES.KPI_CONTRACT_CREATE).length > 0 ||  x.l_roles.filter(y => y.id === enum__PRIVILEGES.GAP_CONTRACT_ANALYZE).length > 0)).length > 0;
};
const daysInMonth = (month, year) => {
    return new Date(parseInt(year), parseInt(month) + 1, 0).getDate();
}

const convertToLocalClientTimeZone = (backEndDate, isAlreadyLocal = false) => {
    if (!backEndDate) return backEndDate;
  
    const fecha = new Date(backEndDate);
  
    const fechaGMT = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds()));
  
    const offsetMin = -fechaGMT.getTimezoneOffset();
    const offsetHoras = Math.floor(Math.abs(offsetMin) / 60);
    const offsetMinutos = Math.abs(offsetMin) % 60;
    const signo = offsetMin >= 0 ? '+' : '-';
    const offsetStr = `GMT${signo}${String(offsetHoras).padStart(2, '0')}:${String(offsetMinutos).padStart(2, '0')}`;

    const fechaLocal = new Date(fechaGMT);

    const diaLocal = String(fechaLocal.getDate()).padStart(2, '0');
    const mesLocal = String(fechaLocal.getMonth() + 1).padStart(2, '0');
    const anioLocal = fechaLocal.getFullYear();
    const horaLocal = String(fechaLocal.getHours()).padStart(2, '0');
    const minutoLocal = String(fechaLocal.getMinutes()).padStart(2, '0');
    const segundoLocal = String(fechaLocal.getSeconds()).padStart(2, '0');

    return `${diaLocal}/${mesLocal}/${anioLocal} ${horaLocal}:${minutoLocal}:${segundoLocal} (${offsetStr})`;
};

const getLocalClientTimeZone = () => {
    const deviceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const today = moment().tz(deviceTimeZone);
    const currentTimeZoneOffsetInHours = today.utcOffset() / 60;

    return currentTimeZoneOffsetInHours;
}

const generarExcel = (data, headerMapping, fileName) => {
    const worksheetData = data.map(obj => {
        const newObj = {};
        for (let prop in headerMapping) {
          if (obj.hasOwnProperty(prop) && prop !== "actions" && prop !== "id") {
            const value = obj[prop];
            if (value instanceof Date) {
              newObj[headerMapping[prop]] = moment(value).format('DD/MM/YYYY');
            } else {
              newObj[headerMapping[prop]] = value;
            }
          }
        }
        return newObj;
    });
    
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blobData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blobData);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName !== undefined && fileName !== null ? fileName : 'Exportación masiva'}.xlsx`); // Nombre personalizado para el archivo
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const calulateSystenDecimal = (value) => {
    let num = value
    let with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    return with2Decimals
}


const compareTwoDates = (dateString1, dateString2) => {

    if (isNullOrEmpty(dateString1)) {
        return false
    }

    const date1 = moment(dateString1);
    const date2 = moment(dateString2);
  
    const startDate1 = date1.startOf('day');
    const startDate2 = date2.startOf('day');
  
    return startDate1.isBefore(startDate2);
}

const checkIfDataserieValueAddMode = (objDataserieValue, inputParam_DataSerie) => {
    let value = null;
    
    if (objDataserieValue === null) {
        return false;
    }

    if (objDataserieValue.locked) {
        if (isNullOrEmpty(objDataserieValue.id) || objDataserieValue.id === 0) {
            value = true;
        }
        else {
            value = false;
        }
    }
    else {
        let nowDate = Date.now();
        let startDate = inputParam_DataSerie.beginDate === null ? inputParam_DataSerie.beginDate : moment(inputParam_DataSerie.beginDate);
        let endDate = inputParam_DataSerie.endDate === null ? inputParam_DataSerie.endDate : moment(inputParam_DataSerie.endDate);

        if (startDate === null && endDate === null) {
            value = true;
        }
        else {
            if (startDate !== null && endDate === null) {
                if (nowDate >= startDate) {
                    value = true;
                }
                else {
                    value = false;
                }
            }
            else {
                if (startDate === null && endDate !== null) {
                    if (nowDate <= endDate) {
                        value = true;
                    }
                    else {
                        value = false;
                    }
                }
                else {
                    if (startDate !== null && endDate !== null) {
                        if (nowDate <= endDate && nowDate >= startDate) {
                            value = true;
                        }
                        else {
                            value = false;
                        }
                    }
                    else {
                        value = false;
                    }
                }
            }
        }
    }
    
    return value;
};

const checkIfDataserieValueEditDeleteMode = (objDataserieValue) => {
    let value = null;
    
    if (objDataserieValue === null) {
        return false;
    }

    if (objDataserieValue.locked !== null) {
        if (objDataserieValue.locked) {
            if (isNullOrEmpty(objDataserieValue.id) || objDataserieValue.id === 0) {
                value = true;
            }
            else {
                value = false;
            }
        }
        else {
            value = true;
        }
    }
    else {
        value = true;
    }

    return value;
};

const isDateExpired = (value) => {
    let dateToday = moment().format('YYYY-MM-DD');
    let dateValueWithFormat = moment(value).format('YYYY-MM-DD');

    return dateValueWithFormat < dateToday;
}

const isDateOnTime = (value) => {
    let dateToday = moment().format('YYYY-MM-DD');
    let dateValueWithFormat = moment(value).format('YYYY-MM-DD');

    return dateValueWithFormat >= dateToday;
}


const convettSignatureDatesToGMTLocal = (originalText) => {
    return originalText.replace(/\b(\d{2})[\/-](\d{2})[\/-](\d{4}) (\d{2}):(\d{2}):(\d{2})\b/g, (_, mes, dia, anio, hora, minuto, segundo) => {
        const fechaGMT = new Date(Date.UTC(anio, mes - 1, dia, hora, minuto, segundo));

        const offsetMin = -fechaGMT.getTimezoneOffset();
        const offsetHoras = Math.floor(Math.abs(offsetMin) / 60);
        const offsetMinutos = Math.abs(offsetMin) % 60;
        const signo = offsetMin >= 0 ? '+' : '-';
        const offsetStr = `GMT${signo}${String(offsetHoras).padStart(2, '0')}:${String(offsetMinutos).padStart(2, '0')}`;

        const fechaLocal = new Date(fechaGMT);

        const diaLocal = String(fechaLocal.getDate()).padStart(2, '0');
        const mesLocal = String(fechaLocal.getMonth() + 1).padStart(2, '0');
        const anioLocal = fechaLocal.getFullYear();
        const horaLocal = String(fechaLocal.getHours()).padStart(2, '0');
        const minutoLocal = String(fechaLocal.getMinutes()).padStart(2, '0');
        const segundoLocal = String(fechaLocal.getSeconds()).padStart(2, '0');

        return `${diaLocal}/${mesLocal}/${anioLocal} ${horaLocal}:${minutoLocal}:${segundoLocal} (${offsetStr})`;
    });
};

const qrToPng = (value, size = 128) => {
    return QRCodePNG.toDataURL(value, { width: size, margin: 1 }); // ← PNG
}

// utils/stripItalicUnderline.ts
function stripItalicAndUnderline(html) {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // 1) Desenrollar etiquetas que implican italic/underline
  //    Agregamos <ins> para tu caso
  ["i", "em", "u", "ins"].forEach((tag) => {
    const nodes = Array.from(doc.body.querySelectorAll(tag));
    nodes.forEach((node) => {
      const parent = node.parentNode;
      while (node.firstChild) parent.insertBefore(node.firstChild, node);
      parent.removeChild(node);
    });
  });

  // 2) Quitar estilos inline equivalentes
  const styled = Array.from(doc.body.querySelectorAll("[style]"));
  styled.forEach((el) => {
    const style = el.getAttribute("style") || "";
    let cleaned = style
      // cursiva
      .replace(/font-style\s*:\s*italic\s*;?/gi, "")
      // subrayado (solo remueve la parte underline, conserva otras decoraciones si existen)
      .replace(/text-decoration\s*:\s*([^;]*)(;|$)/gi, (_, val, end) => {
        // elimina 'underline' de la lista de decoraciones
        const rest = val
          .split(/\s+/)
          .filter(token => !/underline/i.test(token))
          .join(" ")
          .trim();
        return rest ? `text-decoration: ${rest}${end}` : end ? end : "";
      });

    // Normaliza ; duplicados y espacios
    cleaned = cleaned
      .replace(/\s*;\s*(;|$)/g, ";")
      .replace(/^\s*;\s*|\s*;\s*$/g, "")
      .trim();

    if (cleaned) el.setAttribute("style", cleaned);
    else el.removeAttribute("style");
  });

  // 3) (Opcional) Quitar clases típicas
  Array.from(doc.body.querySelectorAll("[class]")).forEach((el) => {
    const filtered = el.className
      .split(/\s+/)
      .filter((c) => !/italic|underline/i.test(c))
      .join(" ");
    if (filtered) el.className = filtered;
    else el.removeAttribute("class");
  });

  return doc.body.innerHTML;
}

function markStrikethrough(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  ["del", "s", "strike"].forEach(tag => {
    doc.body.querySelectorAll(tag).forEach(node => {
      const wrapper = doc.createElement("span");
      wrapper.setAttribute("data-strike", "1");
      // mueve los hijos al wrapper
      while (node.firstChild) wrapper.appendChild(node.firstChild);
      node.parentNode.replaceChild(wrapper, node);
    });
  });
  return doc.body.innerHTML;
}

function normalizeInlineColorAndSize(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  const all = Array.from(doc.body.querySelectorAll("*"));

  all.forEach((el) => {
    const style = el.getAttribute("style");
    if (!style) return;

    const colorMatch = style.match(/color\s*:\s*([^;]+)/i);
    const fsMatch   = style.match(/font-size\s*:\s*([^;]+)/i);

    let hasAny = false;

    if (colorMatch) {
      el.setAttribute("data-color", colorMatch[1].trim());
      hasAny = true;
    }
    if (fsMatch) {
      el.setAttribute("data-font-size", fsMatch[1].trim());
      hasAny = true;
    }

    if (hasAny) {
      // agrega clase 'has-cf' sin perder otras
      const cls = (el.getAttribute("class") || "").trim();
      el.setAttribute("class", (cls ? cls + " " : "") + "has-cf");

      // (opcional) eliminar las partes del style para evitar conflictos
      let cleaned = style
        .replace(/color\s*:\s*[^;]+;?/gi, "")
        .replace(/font-size\s*:\s*[^;]+;?/gi, "")
        .replace(/\s*;\s*(;|$)/g, ";")
        .replace(/^\s*;\s*|\s*;\s*$/g, "")
        .trim();

      if (cleaned) el.setAttribute("style", cleaned);
      else el.removeAttribute("style");
    }
  });

  return doc.body.innerHTML;
}

function cleanStyleKeepColorAndFontSize(html) {
  if (!html) return "";

  // Buscamos todos los atributos style="..."
  return html.replace(/style\s*=\s*(['"])(.*?)\1/gi, (match, quote, styleContent) => {
    // Dividimos las propiedades CSS
    const props = styleContent.split(";").map(p => p.trim()).filter(Boolean);

    // Filtramos solo las que queremos conservar
    const kept = props.filter(p => /^color\s*:|^font-size\s*:/i.test(p));

    if (kept.length === 0) {
      // Si no queda nada útil, eliminamos el atributo style completo
      return "";
    }

    // Reconstruimos el atributo style con solo color y font-size
    return `style=${quote}${kept.join("; ")}${quote}`;
  });
}

function cleanSpanKeepColorAndFontSize(html) {
  if (!html) return "";

  const doc = new DOMParser().parseFromString(html, "text/html");
  const spans = Array.from(doc.body.querySelectorAll("span"));

  spans.forEach((span) => {
    let style = span.getAttribute("style") || "";

    // 1) Extraer props del style (acepta ; o , como separadores)
    const props = style
      .split(/[;,]/)
      .map((p) => p.trim())
      .filter(Boolean);

    // 2) Incluir data-color / data-font-size si existen
    const dataColor = span.getAttribute("data-color");
    const dataFontSize = span.getAttribute("data-font-size");
    if (dataColor) props.push(`color: ${dataColor}`);
    if (dataFontSize) props.push(`font-size: ${dataFontSize}`);

    // 3) Quedarse solo con color y font-size
    const kept = props.filter((p) => /^color\s*:|^font-size\s*:/i.test(p));

    // 4) Reconstruir style limpio
    if (kept.length > 0) {
      span.setAttribute("style", kept.join("; "));
    } else {
      span.removeAttribute("style");
    }

    // 5) Eliminar todos los atributos EXCEPTO:
    //    - style (ya limpio)
    //    - data-strike (lo necesitamos para el tachado en el PDF)
    Array.from(span.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      if (name !== "style" && name !== "data-strike") {
        span.removeAttribute(attr.name);
      }
    });
  });

  return doc.body.innerHTML;
}

const excelDateToJSDate = (value) => {
	if (value === null || value === undefined || value === "") {
		return null;
	}

	if (isNaN(value)) {
		return value;
	}

	return moment('1899-12-30')
		.add(Number(value), 'days')
		.toDate();
};

// «Día de vencimiento» de una obligación mensual a partir de sus dos marcas (ultimoDiaMes manda). null si todavía no se eligió.
const getDueDayRule = (obligation) => {
	if (isNullUndefined(obligation)) {
		return null;
	}

	if (obligation.ultimoDiaMes === true) {
		return enum__DueDayRule.LAST_DAY_OF_MONTH;
	}

	if (isNullUndefined(obligation.respertarUbicacionReferencia)) {
		return null;
	}

	return obligation.respertarUbicacionReferencia ? enum__DueDayRule.SAME_WEEKDAY : enum__DueDayRule.SAME_DAY_NUMBER;
};

// Texto de «Día de vencimiento» para grillas y fichas. Solo aplica a la escala mensual; sin elegir, la API usa el mismo número de día.
const getDueDayRuleText = (obligation, t) => {
	if (isNullUndefined(obligation) || obligation.escalaTiempo !== enum__TimeScale.MONTHS) {
		return t('data-lang-lbl-notapplicable');
	}

	const rule = getDueDayRule(obligation) ?? enum__DueDayRule.SAME_DAY_NUMBER;

	return t(__DueDayRule.find(x => x.key === rule).value);
};

// Vencimiento que se corre por «Vencimiento se posterga»: la API manda la fecha guardada y el día en que vence de verdad
// (sábado y domingo pasan al lunes). Si no son el mismo día devuelve «sáb 28-Feb-26, vence lun 02-Mar-26»; si no, null y la
// pantalla muestra la fecha como siempre.
const getPostponedDueDateText = (dueDate, effectiveDueDate, t, format = 'DD-MMM-YY') => {
	if (isNullUndefinedOrEmpty(dueDate) || isNullUndefinedOrEmpty(effectiveDueDate)) {
		return null;
	}

	const due = moment(dueDate);
	const effective = moment(effectiveDueDate);

	if (effective.isSame(due, 'day')) {
		return null;
	}

	return `${t(`data-lang-lbl-weekday-short-${due.day()}`)} ${due.format(format)}, ${t('data-lang-lbl-dueon')} ${t(`data-lang-lbl-weekday-short-${effective.day()}`)} ${effective.format(format)}`;
};

export {
    getDueDayRule,
    getDueDayRuleText,
    getPostponedDueDateText,
    excelDateToJSDate,
    parseMesAnioEs,
    daysInMonth,
    generarExcel,
    setLocalStorageValue,
    getLocalStorageValue,
    changeCalendarPickerLanguage,
    canEditBoardOrGap,
    canEditBoardOrGapByElement,
    showMessage,
    getNextTechStepBoardConfig,
    getNextTechStepBulkUpload,
    getNextTechStepGapPage,
    isNullOrEmpty,
    isNullUndefined,
    isNullUndefinedOrEmpty,
    isNullUndefinedOrEmptyOrZero,
    isNullUndefinedOrEmptyOrNegative,
    isNullUndefinedOrNegative,
    treeify,
    joinWithoutDupes,
    getKeyByValue,
    getKeyByDictionary,
    visibilityButtonSave,
    visibilityButtonCirculate,
    visibilityButtonSendToApprove,
    visibilityControlSendToVisa,
    visibilityButtonSend,
    visibilityButtonBreakeVisa,
    visibilityButtonSignMessage,
    visibilityButtonDelete,
    downloadURI,
    chunkArray,
    getWindowDimensions,
    base64ToArrayBuffer,
    base64ToBlob,
    saveByteArray,
    setGlobalListPageSize,
    getGlobalListPageSize,
    setGlobalCompactViewMode,
    getGlobalCompactViewMode,
    visibilityButtonSaveWMessageId,
    visibilityButtonCirculateWMessageId,
    encryptBase64,
    decryptBase64,
    calculateTimeLeft,
    stringFormat,
    getAuth,
    fieldSorter,
    setGlobalMessageLayout,
    getGlobalMessageLayout,
    checkIfSelectedSectionStadisticTypeCanBeDisplay,
    isValidDate,
    validateZeroAchievementFactorValue,
    download,
    downloadFile,
    downloadCSV,
    formatNumber,
    groupList,
    compareKeys,
    insertAfter,
    dynamicSort,
    convertToMilitarHour,
    addFieldPropertyToDropDownList,
    isDecimalValue,
    setHelpConfig,
    getHelpConfig,
    processKpiValsByOperation,
    setBoardFieldDisplay,
    getBoardFieldDisplay,
    getLocaleConfig,
    getBoardCalendarFilterConfig,
    setBoardCalendarFilterConfig,
    nestedCopy,
    calulateSystenDecimal,
    compareTwoDates,
    checkIfDataserieValueAddMode,
    checkIfDataserieValueEditDeleteMode,
    convertToLocalClientTimeZone,
    getLocalClientTimeZone,
    getGridLocalization,
    firstDayNextMonthAYearBefore,
    isDateExpired,
    isDateOnTime,
    convettSignatureDatesToGMTLocal,
    markStrikethrough,
    isBookApproverOrCreator,
    isBookApprover,
    isBookConfigureRol,
    removeSpecificTags,
    qrToPng,
    stripItalicAndUnderline,
    normalizeInlineColorAndSize,
    cleanStyleKeepColorAndFontSize,
    cleanSpanKeepColorAndFontSize
}